// Shared @react-google-maps/api loader config.
//
// The Google Maps JS script is a page-wide singleton. If two components call
// useJsApiLoader with different `libraries` arrays, the second one throws
// "Loader must not be called again with different options."
//
// Every caller in this app must import GOOGLE_MAPS_LOADER_OPTIONS and pass it
// verbatim to useJsApiLoader. The array is module-level (stable identity) so
// React doesn't see a "new options" object on each render.

const GOOGLE_MAPS_KEY = process.env.REACT_APP_GOOGLE_MAPS_KEY;

// Union of every library used across the app. Add to this list — never make
// a one-off `libraries: [...]` next to a useJsApiLoader call.
const GOOGLE_MAPS_LIBRARIES = ['drawing', 'places'];

export const GOOGLE_MAPS_LOADER_OPTIONS = {
  id: 'google-map-script',
  googleMapsApiKey: GOOGLE_MAPS_KEY,
  libraries: GOOGLE_MAPS_LIBRARIES,
};
